const IS_TEXTERIFY_CLOUD = process.env.PROPRIETARY_MODE === "true";

export { IS_TEXTERIFY_CLOUD };
